<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">إضافة خدمة</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/mIssues">خدمات الصيانة</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">إضافة خدمة</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row justify-content-center">
          <div class="col-12 col-sm-10">
            <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
            <mainLoader v-if="mainLoading" />
            <ServicesForm v-if="!mainLoading" 
              cardTitle="إضافة خدمة" 
              :categoryChoices="categoryChoices"
            />
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import ServicesForm from './form.vue';

export default {
  name: 'ServicesCreate',
  components: {
    ServicesForm,
  }, 
  data(){
    return {
      mainLoading: false,
      hasError: false,
      message: '',
      errorNumber: 0,
      categoryChoices: {},
    };
  },
  created() {
    this.$http.get('/api/admin/mIssues/list', { params: { page: 1 } })
      .then(({ data }) => {
        this.categoryChoices = data.categoryChoices ?? {};
        this.mainLoading = false;
      })
      .catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError    = true;
        this.mainLoading = false;
      });
  },
}
</script>
